import React, { useEffect } from 'react';
import BuyBeltInit from '../../shims/buy-belt-init';

function ExpressDetails({
	details,
  fulfillmentDetails={},
 	select=()=>{}
}) {
  useEffect(() => {
    BuyBeltInit.initHowItWorks()
    // return function cleanup() {};
  }, []);

  const deliveryDay = (details.storeDeliveryTimeline==="today")?"Today":((details.storeDeliveryTimeline==="tomorrow")?"Tomorrow":"");
  const covidMessaging = fulfillmentDetails.showBodfsCovidAlert ?
      <span className="dai_detailsMessage">
        	Schedule delivery at checkout&nbsp;
      </span> :
      <span className="dai_detailsMessage">
        	Get it scheduled for delivery as soon as&nbsp;
          <span className="u__bold" data-automation-id="pickupDay">
      			{deliveryDay} &nbsp;
      		</span>
      </span>;
  if(deliveryDay){
    return (
      <div className="heading-message">
          {covidMessaging}
        <div>
  		    <a className="u__default-link how_it_works howItWorksReact" id="howItWorksReact">How It Works</a>
        </div>
      </div>
    );
  }else{
    return (
      <div className="heading-message">
        <span className="dai_detailsMessage">
          Schedule Express Delivery at your convenience.&nbsp;
        </span>
        <div>
          <a className="u__default-link how_it_works howItWorksReact" id="howItWorksReact">How It Works</a>
        </div>
      </div>
    );
  }
}

export default ExpressDetails;
